import type { LookaheadDepth, ThemeSettings } from './theme-store.js';

export type AssistancePresetId = 'beginner' | 'medium' | 'advanced';

/** The teaching-aid subset of `ThemeSettings` a preset controls. */
export type AssistanceSettings = Pick<
  ThemeSettings,
  'highlightMovable' | 'showMovePaths' | 'warnUnsafeMoves' | 'showCoords' | 'showMinimap' | 'lookaheadEnabled' | 'lookaheadDepth'
>;

export const ASSISTANCE_PRESETS: Record<AssistancePresetId, AssistanceSettings> = {
  beginner: {
    highlightMovable: true,
    showMovePaths: true,
    warnUnsafeMoves: true,
    showCoords: true,
    showMinimap: true,
    lookaheadEnabled: true,
    lookaheadDepth: 2 satisfies LookaheadDepth,
  },
  medium: {
    highlightMovable: false,
    showMovePaths: false,
    warnUnsafeMoves: true,
    showCoords: true,
    showMinimap: false,
    lookaheadEnabled: true,
    lookaheadDepth: 1,
  },
  advanced: {
    highlightMovable: false,
    showMovePaths: false,
    warnUnsafeMoves: false,
    showCoords: false,
    showMinimap: false,
    lookaheadEnabled: false,
    lookaheadDepth: 1,
  },
};

/** The preset the current settings match exactly, or null once the player has
 *  tweaked an individual toggle ("custom"). Depth is ignored while look-ahead
 *  is off, since it is not consulted then. */
export function matchAssistancePreset(s: AssistanceSettings): AssistancePresetId | null {
  for (const id of Object.keys(ASSISTANCE_PRESETS) as AssistancePresetId[]) {
    const p = ASSISTANCE_PRESETS[id];
    if (
      p.highlightMovable === s.highlightMovable &&
      p.showMovePaths === s.showMovePaths &&
      p.warnUnsafeMoves === s.warnUnsafeMoves &&
      p.showCoords === s.showCoords &&
      p.showMinimap === s.showMinimap &&
      p.lookaheadEnabled === s.lookaheadEnabled &&
      (!p.lookaheadEnabled || p.lookaheadDepth === s.lookaheadDepth)
    ) {
      return id;
    }
  }
  return null;
}
